import { MAP_GL_COLORS, MAP_DEFAULT_CENTER } from '../constants';

/**
 * Group shops by GL and assign colors
 */
export const groupShopsByGL = (shops) => {
    const groups = {};
    shops.forEach(shop => {
        if (shop.gl) {
            if (!groups[shop.gl]) {
                groups[shop.gl] = {
                    shops: [],
                    color: MAP_GL_COLORS[Object.keys(groups).length % MAP_GL_COLORS.length]
                };
            }
            groups[shop.gl].shops.push(shop);
        }
    });
    return groups;
};

/**
 * Filter items with valid coordinates
 */
export const filterValidCoordinates = (items) => {
    return items.filter(item =>
        item.lat && item.lng &&
        !isNaN(parseFloat(item.lat)) &&
        !isNaN(parseFloat(item.lng))
    );
};

/**
 * Calculate map bounds to fit all points
 */
export const calculateMapBounds = (validShops, validCabinets) => {
    const allPoints = [...validShops, ...validCabinets];

    if (allPoints.length === 0) {
        return MAP_DEFAULT_CENTER;
    }

    const lats = allPoints.map(point => parseFloat(point.lat));
    const lngs = allPoints.map(point => parseFloat(point.lng));

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);

    const centerLat = (minLat + maxLat) / 2;
    const centerLng = (minLng + maxLng) / 2;

    // Calculate zoom level based on bounds
    const latDiff = maxLat - minLat;
    const lngDiff = maxLng - minLng;
    const maxDiff = Math.max(latDiff, lngDiff);

    let zoom = 10;
    if (maxDiff < 0.01) zoom = 15;
    else if (maxDiff < 0.05) zoom = 13;
    else if (maxDiff < 0.1) zoom = 11;
    else if (maxDiff < 0.5) zoom = 9;
    else zoom = 7;

    return {
        longitude: centerLng,
        latitude: centerLat,
        zoom: zoom
    };
};

/**
 * Get shop style based on GL group and new shop
 */
export const getShopStyle = (shop, shopGroups) => {
    const group = shopGroups[shop.gl];
    const baseColor = group ? group.color : '#666666';

    return {
        backgroundColor: baseColor,
        borderColor: baseColor,
        opacity: !shop.openedAt ? 1 : 0.9,
        transform: !shop.openedAt ? 'scale(1)' : 'scale(0.9)',
    };
};

/**
 * Get cabinet style based on associated shop
 */
export const getCabinetStyle = (cabinet, validShops, shopGroups) => {
    const associatedShop = validShops.find(shop => shop.code === cabinet.shop_code);
    if (associatedShop && shopGroups[associatedShop.gl]) {
        const baseColor = shopGroups[associatedShop.gl].color;
        return {
            backgroundColor: baseColor,
            borderColor: baseColor,
            opacity: 0.9
        };
    }
    return {
        backgroundColor: '#999999',
        borderColor: '#999999',
    };
};

/**
 * Filter visible items based on hidden groups
 */
export const filterVisibleByGroups = (items, hiddenGroups, getGroupKey = (item) => item.gl) => {
    return items.filter(item => !hiddenGroups.has(getGroupKey(item)));
};

/**
 * Filter visible cabinets based on their shop's group
 */
export const filterVisibleCabinets = (cabinets, validShops, hiddenGroups) => {
    return cabinets.filter(cabinet => {
        const associatedShop = validShops.find(shop => shop.code === cabinet.shop_code);
        return !associatedShop || !hiddenGroups.has(associatedShop.gl);
    });
};
